import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { tryUnlockFromToken, hasUnlockToken } from '../services/unlockToken'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  
  {
    path: '/result',
    name: 'result',
    component: () => import('../views/ResultView.vue')
  },
  {
    path: '/shiken/:shikenId/type/:shikenType/start',
    name: 'startQuestion',
    component: () => import('../views/StartQuestion.vue')
  },

  {
    path: '/shiken/:shikenId/q/:id',
    name: 'question',
    component: () => import('../views/Question.vue')
  },
  {
    path: '/auth/:grade',
    name: 'Auth',
    component: () => import('../views/Auth.vue')
  },
  {
    path: '/login',
    name: 'Start',
    component: () => import('../views/Start.vue')
  },
  {
    path: '/:grade',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'Start',
    component: () => import('../views/Start.vue')
  },
  

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //      return savedPosition
  //   } else {
  //      return { x: 0, y: 0 }
  //   }
  // }
})

// 外部サイトから #t=<署名トークン> 付きで遷移してきた場合、
// HomeView の認証チェック（未認証なら /auth へリダイレクト）が走る前に
// 署名を検証して対象級の試験1を解放する。検証後はフラグメントを除去し、
// トークンの級に対応する試験TOP（/3・/2）へ着地させる。
// 画面には何も表示しない（サイレント）。
router.beforeEach(async (to, from, next) => {
  if (hasUnlockToken(to.hash)) {
    const grade = await tryUnlockFromToken(to.hash)
    const path = grade ? '/' + grade : to.path
    next({ path, query: to.query, hash: '', replace: true })
    return
  }
  next()
})

export default router
